import dayjs from "dayjs";

/**
 * Blob-path helpers for demo/clone sites.
 *
 * A demo site cloned from a real site has no imagery of its own. Its crop
 * metadata may therefore carry:
 *   - CLOUD_SITE_PREFIX: the source site's name, used in place of the demo
 *     site's own name when building blob paths.
 *   - CLOUD_DATE_OFFSETS: { [greenhouseName]: days } — the demo's dates are the
 *     source's dates shifted forward by this many days per greenhouse, so the
 *     blob date is the UI date minus the offset.
 *
 * Both keys are absent on ordinary sites, so behaviour there is unchanged.
 */

const BLOB_DATE_FORMAT = "YYYY-MM-DD";

export const blobSitePrefix = (siteMetadata, currentSite) =>
  siteMetadata?.CLOUD_SITE_PREFIX || currentSite?.name;

export const blobDate = (siteMetadata, greenhouseName, date) => {
  const offset = Number(siteMetadata?.CLOUD_DATE_OFFSETS?.[greenhouseName]);
  if (!date || !offset || !Number.isFinite(offset)) return date;
  return dayjs(date, BLOB_DATE_FORMAT).subtract(offset, "day").format(BLOB_DATE_FORMAT);
};
